<template>
  <div>
    <div class="d-flex align-items-center">
      <h5 class="me-2">Performance</h5>
      <img class="mt-2" src="@/assets/images/Performance.svg" />
    </div>

    <b-card class="Performance-card performance-padding">
      <div class="table-container">
        <table class="freeze-table">
          <thead class="text-center">
            <tr>
              <th class="sticky-col">Period</th>
              <th v-for="header in headers.slice(1)" :key="header.prop">
                {{ header.label }}
              </th>
            </tr> 
          </thead>
          <tbody>
          
            <tr v-for="(row, rowIndex) in performanceData" :key="rowIndex">
              <td class="sticky-col">{{ row.name }}</td>
              <td
                class="text-center"
                v-for="header in headers.slice(1)"
                :key="header.prop"
              >
                {{
                  isNaN(row[header.prop])
                    ? '-'
                    : Number(row[header.prop]).toFixed(1) + '%'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <a class="text-decoration-none cursor-pointer" @click="toggleView">
          View {{ showMore ? 'less' : 'top peers' }}
          <span class="text-dark">{{ showMore ? '▲' : '▼' }}</span>
        </a>
      </div>
    </b-card>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const showMore = ref(false)

const rawPerformance = computed(
  () => store.getters.schemeData?.performance || {}
)

const periodKeys = [
  { key: '1dayret', label: '1D' },
  { key: '1weekret', label: '1W' },
  { key: '1monthret', label: '1M' },
  { key: '3monthret', label: '3M' },
  { key: '6monthret', label: '6M' },
  { key: '1yrret', label: '1Y' },
  { key: '3yearret', label: '3Y' },
  { key: '5yearret', label: '5Y' },
]

const schemeNames = computed(() => Object.keys(rawPerformance.value))

const headers = computed(() => [
  { prop: 'name', label: 'Scheme Name' },
  ...periodKeys.map(({ key, label }) => ({ prop: key, label })),
])

const performanceData = computed(() => {
  const allData = schemeNames.value.map((name) => {
    const scheme = rawPerformance.value[name] || {}
    const row = {
      name: name.split('(G)')[0].trim(),
    }
    periodKeys.forEach(({ key }) => {
      row[key] = scheme[key] ?? '-'
    })
    return row
  }) 

  const categoryData = []
  const peerData = []

  let categoryFound = false

  allData.forEach((row) => {
    if (!categoryFound) {
      categoryData.push(row)
      if (row.name.includes('Category Average')) {
        categoryFound = true
      }
    } else {
      peerData.push(row)
    }
  })

  return showMore.value ? [...categoryData, ...peerData] : categoryData
})

const toggleView = () => {
  showMore.value = !showMore.value
}

onMounted(() => {})
</script>

<style scoped>

@media (max-width: 450px) {
  .performance-padding .card-body {
    padding: 0 !important;
    /* other responsive overrides */
  }
}


.Performance-card {
  background: #ffffff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
}

.freeze-table {
  border-collapse: collapse;
  min-width: 1000px;
  width: 100%;
  border: none !important;
}

.freeze-table th,
.freeze-table td {
  padding: 8px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.freeze-table td:nth-child(odd) {
  background-color: #f7f7f7;
}

.freeze-table td:nth-child(even) {
  background-color: #ffffff;
}

.sticky-col {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 150px;
  max-width: 200px;
  width: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  background: white;
}

.freeze-table thead .sticky-col {
  z-index: 2;
}

@media (max-width: 1200px) {
  .freeze-table {
    table-layout: auto;
  }

  .table-container {
    overflow-x: auto;
  }
}
@media (max-width: 500px) {
  .Performance-card {
    border-radius: 0;
    margin-left: -16px;
    margin-right: -16px;
  }

  .sticky-col {
    width: 173px !important;
  }
}
</style>
